"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertAddressNotSanctioned = void 0;
const axios_1 = __importDefault(require("axios"));
const ADDRESS_VALIDATION_URL = 'https://api.proxy.shapeshift.com/api/v1/validate';
const assertAddressNotSanctioned = async (address) => {
    const valid = await (async () => {
        try {
            const { data } = await axios_1.default.get(`${ADDRESS_VALIDATION_URL}/${address}`);
            return data.valid;
        }
        catch (err) {
            // Log the error for debugging purposes
            console.error(`Error validating address: ${address}. Defaulting to valid.`, err);
            return true;
        }
    })();
    if (!valid)
        throw Error('Address not supported');
};
exports.assertAddressNotSanctioned = assertAddressNotSanctioned;
